import { graphql } from '@/client/services/api/graphql/gql';

export const disableExpertMutation = graphql(`
  mutation DisableExpert($expertId: String!) {
    disableExpert(expertId: $expertId)
  }
`);
